import React, { type ReactElement } from 'react'
import { Typography } from '@mui/material'
import { ReactComponent as PlusIcon } from 'assets/plusIcon.svg'
import { ReactComponent as EditIcon } from 'assets/editIcon.svg'
import cx from 'classnames'

import styles from './VendorInfoPanel.module.scss'

interface VendorInfoPanelProps {
  title: string
  className?: string
  icon?: ReactElement
  empty?: boolean
  style?: React.CSSProperties
  contentClassName?: string
  rightHeaderClassName?: string
  contentStyle?: React.CSSProperties
  onClick?: () => void
  children?: ReactElement | ReactElement[] | string | number
  rightHeader?: ReactElement | ReactElement[] | string | number
}

const VendorInfoPanel: React.FC<VendorInfoPanelProps> = ({
  title,
  icon,
  empty,
  className,
  style,
  contentClassName,
  rightHeaderClassName,
  contentStyle,
  onClick,
  children,
  rightHeader,
}): ReactElement => {
  return (
    <div className={cx(styles.container, className)} style={style}>
      <div className={styles.header}>
        <div className={styles.title}>
          <div>{icon}</div>
          <Typography className={styles.titleText} variant="title5" style={{ lineHeight: '20px' }}>
            {title}
          </Typography>
        </div>
        {rightHeader && (
          <div className={cx(styles.rightHeaderStyle, rightHeaderClassName)}>{rightHeader}</div>
        )}
        {empty !== undefined ? (
          empty ? (
            <EditIcon fill="white" cursor="pointer" onClick={onClick} />
          ) : (
            <PlusIcon cursor="pointer" onClick={onClick} />
          )
        ) : (
          <></>
        )}
      </div>
      <div className={cx(styles.content, contentClassName)} style={contentStyle}>
        {children}
      </div>
    </div>
  )
}

export default VendorInfoPanel
